define('OrderHistory.Details.View.LimitQty', [
  'OrderHistory.Details.View',
  'LimitItemQuantity.MyAccount.Helper',
  'underscore'
], function LimitItemQuantityMyAccount(
  OrderHistoryDetailsView,
  Helper,
  _
) {
  'use strict';

  _.extend(OrderHistoryDetailsView.prototype, {
    addToCart: _.wrap(OrderHistoryDetailsView.prototype.addToCart, function addToCart(fn, e) {
      var event = _.toArray(arguments).slice(1);
      if (Helper.validateAddToCart(this, e)) {
        fn.apply(this, event);
      }
    })
  });
});
